<template>
  <div class="courier91">
    <ul class="call_detail_item">
      <li class="inputFeild">
        <label>
          <span>{{$t('name')}} :</span>
        </label>
        <input :placeholder="$t('name')" type="text" v-model="form.user_name" />
      </li>
      <li class="inputFeild">
        <label>
          <span>{{$t('pincode')}} :</span>
        </label>
        <input :placeholder="$t('pincode')" type="number" v-model="form.user_pin_code" />
      </li>
      <li class="inputFeild">
        <label>
          <span>{{$t('supportedPincode')}} :</span>
        </label>
        <div class="supported-pincode">
          <ul class="chiplisting">
            <li v-for="(pincode, index) in form.service_pin_code" :key="index">
              <Span class="text-label">{{ pincode }}</Span>
              <span class="close" @click="removeTodo(index)">x</span>
            </li>
          </ul>

          <input
            :placeholder="$t('supportedPincode')"
            inputType="number"
            name="service_pin_code"
            v-model="addedpincode"
            id="suptpin"
          />
        </div>
      </li>
      <li class="inputFeild">
        <label>
          <span>{{$t('city')}} :</span>
        </label>
        <input type="text" :placeholder="$t('city')" v-model="form.user_city" />
      </li>
      <li class="inputFeild">
        <label>
          <span>{{$t('phoneNumber')}} :</span>
        </label>
        <input :placeholder="$t('phoneNumber')" v-model="form.phone_number" />
      </li>
    </ul>
    <button type="button" class="submit" @click="submitForm()">SUBMIT</button>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
  </div>
</template>
<script>
import constant from "../../utils/constant";
import { PINCODE_REGEX } from "../../utils/constant";
import { isPinCodeNumber } from "../../utils/Validator";
import CustomToaster from "../../components/Common/CustomToaster";

export default {
  name: "courierFamily",
  components: {
    CustomToaster
  },
  data() {
    return {
      form: {
        user_name: "",
        user_pin_code: "",
        phone_number: "",
        user_city: "",
        service_pin_code: []
      },
      toasterData: {},
      isValidDetail: false,
      buttonDisable: false,
      NumOfPin: 0,
      separateArray: []
    };
  },
  computed: {
    addedpincode: {
      get() {
        this.buttonDisable = false;
        return this.value;
      },

      async set(value) {
        this.buttonDisable = false;
        this.$emit("input", value);
        if (isPinCodeNumber(value) && value) {
          if (!this.separateArray.includes(value)) {
            this.form.service_pin_code.push(value);
            this.separateArray = this.form.service_pin_code.join();
            this.$emit("supportedpincodeUpdated", this.separateArray);
            this.value = "";
          } else {
            document.getElementById("suptpin").value = "";
          }
        } else if (!value && !this.NumOfPin) {
          this.$emit("supportedpincodeUpdated", null);
        }
        return;
      }
    }
  },
  methods: {
    removeTodo(index) {
      if (this.form.service_pin_code.length > 1) {
        this.form.service_pin_code.splice(index, 1);
        this.$emit(
          "supportedpincodeUpdated",
          this.form.service_pin_code.join()
        );
      } else {
        this.form.service_pin_code.splice(index, 1);
        this.$emit("supportedpincodeUpdated", null);
      }
      this.value = "";
    },

    validateFields() {
      if (
        !this.form.user_name ||
        !this.form.phone_number ||
        !this.form.user_pin_code ||
        !this.form.user_city ||
        !this.form.service_pin_code.length
      ) {
        this.toasterData = {
          msg: this.$t("enterAllFeilds"),
          color: "#e51c24",
          iconName: "close"
        };
        this.isValidDetail = true;
        return false;
      } else {
        if (this.form.user_name.length <= 3) {
          this.toasterData = {
            msg: this.$t("enterValidName"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (this.form.phone_number.length != "") {
          if (
            !new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(
              this.form.phone_number
            )
          ) {
            this.toasterData = {
              msg: this.$t("enterValidMobileNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        if (this.form.user_city.length <= 4) {
          this.toasterData = {
            msg: this.$t("enterValidAddress"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
          return false;
        }
        if (this.form.user_pin_code.length != "") {
          if (!new RegExp(/^[1-9][0-9]{5}$/g).test(this.form.user_pin_code)) {
            this.toasterData = {
              msg: this.$t("enterValidPinNumber"),
              color: "#e51c24",
              iconName: "close"
            };
            this.isValidDetail = true;
            return false;
          }
        }
        return true;
      }
    },
    submitForm() {
      if (this.validateFields()) {
        this.$emit("formData", this.form);
      }
    }
  },
  mounted() {}
};
</script>
<style scoped>
.supported-pincode {
  width: 75%;
}
.supported-pincode input {
  width: 100%;
}
.chiplisting li {
  width: auto;
  background: #ffffff;
  border-radius: 25px;
  border: 1px solid #dddddd;
  padding: 4px 20px 4px 8px;
  margin: 0 4px 0 0;
  display: inline-block;
  position: relative;
  line-height: 0;
}
.chiplisting li .text-label {
    font-size: 1em;
    color: #000;
    font-weight: 500;
    line-height: normal;
    white-space: nowrap;
    margin-bottom: 0px;
}
.chiplisting li .close {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 2px;
    top: 3px;
    z-index: 9;
    line-height: 1;
    background: #7d7c7c;
    border-radius: 50%;
    text-align: center;
    color: #fff;
}
</style>